<template>
    <rkm-form
        v-if="model"
        ref="RkmForm"
    >
        <BoxLocalAtendimento :data="{form: form.infraestrutura, model: model.infraestrutura}" />
        <BoxAgendamento :data="{model: model.agendamento}" />
        <BoxClassificacaoCadastro :data="{model: model.classificacaoCadastro}" />
        <BoxIntegracaoAplicativo :data="{model: model.integracaoAplicativo}" />
        <BoxHistoricoConectaCidadao :data="{model: model.historicoConectaCidadao}" />
        <BoxAtendimento :data="{model: model.atendimento}" />

        <BoxSigilo
            :data="{form: form.sigilo, model: model.sigilo}"
            class="mt-3"
        />
    </rkm-form>
</template>

<script>
// Components.
import BoxAgendamento from './components/agendamento/Form'
import BoxClassificacaoCadastro from './components/classificacao-cadastro/Form'
import BoxIntegracaoAplicativo from './components/integracao-aplicativo/Form'
import BoxHistoricoConectaCidadao from './components/historico-conecta-cidadao/Form'
import BoxAtendimento from './components/atendimento/Form'
import BoxLocalAtendimento from './components/local-atendimento/Index'
import BoxSigilo from './components/sigilo/Index'

// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    components: {
        BoxAgendamento,
        BoxClassificacaoCadastro,
        BoxIntegracaoAplicativo,
        BoxHistoricoConectaCidadao,
        BoxAtendimento,
        BoxLocalAtendimento,
        BoxSigilo,
    },
    created() {
        this.repositories = {
            parametrizacao: this.getConectaSusRepository('ambulatorio.parametrizacao'),
        }
    },
    data: () => ({
        form: null,
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.parametrizacao.create()
                .then(response => {
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {
             this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    this.setLoading()

                    const request = {
                        infraestrutura: {
                            infraestruturas: this.model.infraestrutura.infraestruturas.map(infraestrutura => {
                                const ocupacoes = infraestrutura.ocupacoes
                                const especialidades = infraestrutura.especialidades
                                const infraestruturasAgendadoras = infraestrutura.infraestruturasAgendadoras
                                const servicos = infraestrutura.servicos
                                const sms = infraestrutura.sms

                                return {
                                    id: infraestrutura.id,
                                    enviaSms: infraestrutura.enviaSms,
                                    faturaProcedimentoRaas: infraestrutura.faturaProcedimentoRaas,
                                    ocupacoes: ocupacoes.map(ocupacao => {
                                        return {
                                            id: ocupacao.id,
                                            posConsulta: ocupacao.posConsulta,
                                            permiteAtendimentoEnfermagem: ocupacao.permiteAtendimentoEnfermagem,
                                            atencaoBasicaFuncionalidades: ocupacao.atencaoBasicaFuncionalidades,
                                        }
                                    }),
                                    especialidades: especialidades.map(especialidade => {
                                        return {
                                            id: especialidade.id,
                                            avisaFaltaQuantidade: especialidade.avisaFaltaQuantidade,
                                            avisaFaltaDias: especialidade.avisaFaltaDias,
                                            quantidadeDiasRetorno: especialidade.quantidadeDiasRetorno,
                                            demandaEspontaneaObservaVagaAtendimento: especialidade.demandaEspontaneaObservaVagaAtendimento,
                                            procedimentos: especialidade.procedimentos.map(procedimento => {
                                                return {
                                                    codigo: procedimento.codigo,
                                                }
                                            })
                                        }
                                    }),
                                    infraestruturasAgendadoras: infraestruturasAgendadoras.map(infraestruturaAgendadora => {
                                        return {
                                            id: infraestruturaAgendadora.id,
                                        }
                                    }),
                                    servicos: servicos.map(servico => servico.id),
                                    sms: {
                                        diaAntecedencia: sms.diaAntecedencia,
                                        envioDe: sms.periodoEnvio.start,
                                        envioAte: sms.periodoEnvio.end,
                                        especialidades: sms.especialidades.map(especialidade => especialidade.id),
                                    },
                                    deleted: infraestrutura.deleted,
                                    assinaturas: infraestrutura.assinaturas,
                                }
                            }),
                        },
                        agendamento: this.model.agendamento,
                        classificacaoCadastro: this.model.classificacaoCadastro,
                        integracaoAplicativo: this.model.integracaoAplicativo,
                        historicoConectaCidadao: this.model.historicoConectaCidadao,
                        atendimento: this.model.atendimento,
                        sigilo: {
                            sigilos: this.model.sigilo.sigilos.map(sigilo => {
                                const infraestruturas = sigilo.infraestruturas
                                const ocupacoes = sigilo.ocupacoes

                                return {
                                    ocupacaoId: sigilo.ocupacao.id,
                                    infraestruturaId: sigilo.infraestruturaId,
                                    sigiloTipoId: sigilo.sigiloTipoId,
                                    infraestruturas: infraestruturas.map(infraestrutura => ({id: infraestrutura.id})),
                                    ocupacoes: ocupacoes.map(ocupacao => ({id: ocupacao.id})),
                                    deleted: sigilo.deleted,
                                }
                            }),
                        },
                    }

                    this.repositories.parametrizacao.store(this.camelObjectKeysToSnakeRecursive(request))
                        .then(() => {
                            this.$emit('saved')
                            this.showSaveNotification()
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
    },
    mixins: [error, repository, stringCase],
    mounted() {
        this.load()
    },
}
</script>